const routes = [
  {
    path: '/custom-lists',
    name: 'custom-lists',
    meta: {
      authRequired: true,
      permission: 'event.config'
    },
    component: () => import('./Index.vue')
  },
  {
    path: '/custom-lists/:id',
    name: 'custom-lists-show',
    meta: {
      authRequired: true,
      permission: 'event.config'
    },
    component: () => import('./Show.vue')
  }
]

export default routes
